<div style="min-width: 400px">
  <div matDialogTitle>{{title}}</div>
  <mat-dialog-content>
    <div>
      @for (item of savingMessage; track item) {
        <p-message [severity]="item.severity">{{item.summary}}</p-message>
      }
    </div>
    <form novalidate class="create-form layout-column-space-around-stretch" [formGroup]="convertForm" style="width: 100%">
      @if (isShowGroup) {
        <ah-group-input [divisionGroups]="divisionGroups$ | async"
          [franchiseGroups]="franchiseGroups$ | async" [notDivisionGroups]="notDivisionGroups$ | async"
          [notFranchiseGroups]="notFranchiseGroups$ | async" [allGroups]="allGroups$ | async"
          [studioId]="studioId" [franchiseId]="franchiseId" [franchise]="franchise"
          [franchiseGroupTable]="franchiseGroupTable" [divisionGroupTable]="divisionGroupTable"
          [divisionId]="divisionId" (selectGroups)="selectGroups($event)"
          [convertSubGroup]="group" [isConvertSubGroup]="true"
          >
        </ah-group-input>
      }

      <mat-form-field class="layout-flex-20 wk-flex-fix">
        <mat-label>{{placeholder}} Name</mat-label>
        <input matInput value="" formControlName="name" maxlength="255" name="name">
      </mat-form-field>
      <mat-form-field class="layout-flex-20 wk-flex-fix">
        <mat-label>Description</mat-label>
        <textarea matInput matAutosizeMaxRows="5" matTextareaAutosize formControlName="description"></textarea>
      </mat-form-field>
    </form>

  </mat-dialog-content>
  <mat-dialog-actions class="flex justify-flex-end gap-20">
    <button mat-raised-button matDialogClose class="flex-20">Cancel</button>
    <button mat-raised-button class="flex-20" [ngStyle]="{'background-color': convertForm?.valid && saveDisabled?'#607d8b' : '#0000001f','color':convertForm?.valid && saveDisabled?'#FFF':'rgba(0, 0, 0, 0.26)' }" (click)="save()" [disabled]="!convertForm?.valid && !saveDisabled">Save</button>
  </mat-dialog-actions>
</div>
